














































































































  import { Vue, Component, Watch } from "vue-property-decorator";
  import { Popup, Picker, DatetimePicker, Calendar, Field, Tag, Dialog } from "vant";
  import productHome from "../modules/productHome.vue";
  import { ApplyArea, Cabin, VoyageType, YesOrNo, ZoneType } from "@/model/Base";
  import dataShare from "../dataShare";
  import * as _ from "lodash";
  import billService from "@/service/billService";
  import { TradeDetailEntity } from "@/model/Bill";
  // import RetainTickets from "./modules/RetainTickets.vue";
  import RetainTickets from "./modules/RetainTickets.vue";
  import huilianyiService from "@/service/huilianyiService";
import moment from "moment";
  @Component({
    components: {
      [Popup.name]: Popup,
      [Picker.name]: Picker,
      [DatetimePicker.name]: DatetimePicker,
      [Calendar.name]: Calendar,
      [Field.name]: Field,
      [Tag.name]: Tag,
      // [Dialog.name]: Dialog as any,
      "product-home": productHome,
      ["retain-tickets"]: RetainTickets,
    },
  })
  export default class Flight extends Vue {
    //data
    arrivePopupVisible = false;
    departPopupVisible = false;
    cabinPopupVisible = false;
    cabins = [
      { text: this.$root.$t("mall_flight_flight_toudengcang") as string, value: Cabin.First },
      { text: this.$root.$t("mall_flight_flight_shangwucang") as string, value: Cabin.Buissenes },
      { text: this.$root.$t("mall_flight_flight_jingjicang") as string, value: Cabin.Economy },
    ];

    VoyageTypes = [
      { text: this.$root.$t("mall_flight_flight_dancheng") as string, value: VoyageType.SingleVoyage, className: "oneWay" },
      { text: this.$root.$t("mall_flight_flight_wangfan") as string, value: VoyageType.RoundVoyage, className: "roundTrip" },
    ];

    citys = [
      { text: this.$root.$t("mall_flight_flight_shanghai") as string, code: "SHA", CountryID: 151 },
      { text: this.$root.$t("mall_flight_flight_beijing") as string, code: "BJS", CountryID: 151 },
      { text: this.$root.$t("mall_flight_flight_guangzhou") as string, code: "CAN", CountryID: 151 },
    ];

    dataShare = dataShare;
    datePickerVisible = false;
    DepartDate = new Date();
    ArriveDate: Date | null = null;

    // selectedCabin = this.cabins[0];
    selectedCabin = {};
    departCity = this.citys[0];
    arriveCity = this.citys[1];
    get ApplyArea() {
      if (this.departCity && this.departCity.CountryID && this.departCity.CountryID != 151) {
        return ApplyArea.Overseas;
      }
      if (this.arriveCity && this.arriveCity.CountryID && this.arriveCity.CountryID != 151) {
        return ApplyArea.Overseas;
      }
      return ApplyArea.Internal;
    }
    query: any = {
      DepartDate: undefined,
      ArriveDate: undefined,
      DepartCity: this.departCity.code,
      ArriveCity: this.arriveCity.code,
      DepartCityName: this.departCity.text,
      ArriveCityName: this.arriveCity.text,
      ApplyArea: this.ApplyArea,
      BookingType: "1529",
      VoyageType: 1161,
      BerthLevel: '',
      ServiceType: "FlightService",
      AdultCount: 1,
      ChildCount: 0,
      InfantCount: 0,
      FeatureCodes: "",
      Consumers: "",
    };
    ymdDate = "YYYY-MM-DD";
    mdDate = this.$root.$t("mall_flight_flight_yueri") as string;
    changeCityFlag = false;
    OneSelf = null;

    get City(): any {
      return this.dataShare.City;
    }
    set City(value: any) {
      this.dataShare.City = value;
    }
   get FlowID() {
      return this.$route.query.FlowID;
    }
    get DepartCity() {
      return this.$route.query.DepartCity;
    }
    get ArriveCity() {
    return this.$route.query.ArriveCity;
    }
    get FeatureCodes() {
      if (this.$route.query.FeatureCodes) {
        return this.$route.query.FeatureCodes;
      }
      return "";
    }
     get SelectConsumers() {
      if (this.$route.query.Consumers) {
        return JSON.parse(this.$route.query.Consumers as string);
      }
    }
    get ReturnDate() {
      return this.$route.query.ReturnDate;
    }
    get AdultCount() {
      return this.$route.query.AdultCount;
    } 
    mounted() {
    const __self = this;
    if (__self.FlowID) {
      const queryData = this.$route.query as any;
      __self.query.BerthLevel = '';
      __self.query.ApplyArea = queryData.ApplyArea;
      __self.query.BookingType = Number(queryData.BookingType);
      if (queryData.DepartCity != "" && queryData.DepartCity != undefined) {
        __self.query.DepartCity = queryData.DepartCity;
        __self.query.DepartCityName = queryData.DepartCityName;
      }
      if (queryData.ArriveCity != "" && queryData.ArriveCity != undefined) {
        __self.query.ArriveCity = queryData.ArriveCity;
        __self.query.ArriveCityName = queryData.ArriveCityName;
      }
      if (queryData.DepartDate || queryData.DepartDate != "") {
        __self.query.DepartDate = queryData.DepartDate;
        __self.DepartDate = queryData.DepartDate;
      }
      if (queryData.ReturnDate || queryData.ReturnDate != "") {
        __self.query.ArriveDate = queryData.ReturnDate;
        __self.ArriveDate = queryData.ReturnDate;
      }
      if (queryData.ReturnDate != "") {
        __self.query.VoyageType = VoyageType.RoundVoyage;
      } else {
        __self.query.VoyageType = VoyageType.SingleVoyage;
      }
    }
      this.City = null;
      this.dataShare.consumers = [];
      this.loadRetainTickets();
      this.searchapproval();
    }

    //activated
    activated() {
      // this.Consumers = dataShare.consumers;
      if (this.selectCode && this.City && this.City.value) {
        let City = this.City;
        if (this.selectCode == "DepartCity") {
          this.departCity = this.City;
          this.query.DepartCityName = City.label;
          this.query.DepartCity = City.value;
          this.query.DepartCode = City.ZoneType == ZoneType.Airport ? City.ZoneCode : null;
        } else if (this.selectCode == "ArriveCity") {
          this.arriveCity = this.City;
          this.query.ArriveCityName = City.label;
          this.query.ArriveCity = City.value;
          this.query.ArriveCode = City.ZoneType == ZoneType.Airport ? City.ZoneCode : null;
        }
        // 选择完成后清空
        this.selectCode = ''
      }
    }

    //methods
    flightFormatter(day?: any) {
      if (day.type === "start") {
        day.bottomInfo = "去程";
      } else if (day.type === "end") {
        day.bottomInfo = "返程";
      }
      if (this.FlowID) {
        const queryData = this.$route.query as any;
        const today = moment().subtract(1, "days").endOf('day'); 
        const starDepartDate = moment(queryData.DepartDate).startOf('day'); // 起始日期开始
        const endDepartDate = queryData.DepartDateEnd ? moment(queryData.DepartDateEnd).endOf('day') : null;// 起始日期结束
        const starReturnDate = moment(queryData.ReturnDate).startOf('day'); // 到达日期开始
        const endReturnDate = queryData.ReturnDateEnd ? moment(queryData.ReturnDateEnd).endOf('day') : null;// 到达日期结束
        // 单程只判断开始日期
        if(this.query.VoyageType == this.VoyageTypes[0].value){
          if (day.date < today || day.date < starDepartDate || (endDepartDate && day.date > endDepartDate)) {
            day.type = "disabled";
          }
        }else{
          if (day.date < today || day.date < starDepartDate || (endDepartDate && day.date > endDepartDate) || day.date < starReturnDate || (endReturnDate && day.date > endReturnDate)) {
            day.type = "disabled";
          }
        }
        
      }
      return day;
    }
    showConsumers() {
      let Flag = true;
      if (this.SelectConsumers && this.SelectConsumers.length > 0) {
        return (Flag = false);
      } else  {
        if(this.OneSelf == YesOrNo.Yes){
          let consumers: any = [
          {
            RoleID: this.profile.UserID,
            RoleName: this.profile.UserName,
          },
          ];
          dataShare.consumers = consumers;
          return (Flag = false);
        }
      }
      return Flag;
    }
    OneSelfs(value: any) {
      this.OneSelf = value;
    }
    @Watch("dataShare.consumers")
    handelConsumers(value: any) {
      this.Consumers = dataShare.consumers;
    }
    formatDate(value: Date, format: string = this.$root.$t("mall_flight_flight_yueri") as string) {
      if (!value) {
        return value;
      }
      return (this as any).$moment(value).format(format);
    }

    onCabinSelect(cabin: any) {
      this.cabinPopupVisible = false;
      this.selectedCabin = cabin;
      this.query.BerthLevel = cabin.value;
    }
    changeVoyageType(voyageType: number) {
      const queryData = this.$route.query as any;
  
      if (!this.FlowID || (!queryData.DepartDate && !queryData.ReturnDate)) {
        this.query.VoyageType = voyageType;
        if (voyageType == VoyageType.RoundVoyage) {
          this.ArriveDate = (this as any).$moment(this.DepartDate).add(1, "days");
        } else {
          this.ArriveDate = null;
        }
        return;
      }

      this.query.VoyageType = this.ReturnDate ? VoyageType.RoundVoyage : VoyageType.SingleVoyage;
    }
    handleSelect(data: Date | Array<Date>) {
      this.datePickerVisible = false;
      if (data instanceof Array && data.length == 2) {
        this.DepartDate = data[0];
        this.ArriveDate = data[1];
      } else if (data instanceof Date) {
        this.DepartDate = data;
      }
    }
    search() {
      if (this.Consumers.length == 0) {
        return this.$root.$toast.fail(this.$root.$t("mall_flight_flight_qingxuanzelvke") as string);
      }
      if (this.SelectConsumers && this.SelectConsumers.length > 0) {
        this.Consumers = this.SelectConsumers;
      }
      if(this.FeatureCodes){
        this.query.FeatureCodes = this.FeatureCodes;
      }
      this.query.DepartDate = this.formatDate(this.DepartDate, this.ymdDate);
      if (this.ArriveDate) {
        this.query.ArriveDate = this.formatDate(this.ArriveDate, this.ymdDate);
      }
      this.query.Consumers = JSON.stringify(this.Consumers.map((o: any) => ({ ConsumerID: o.RoleID, ConsumerName: o.RoleName })));
      if (dataShare.bookingType) {
        this.query.BookingType = dataShare.bookingType;
      }
      this.query.ApplyArea = this.ApplyArea;
      if (this.ApplyArea == 1126) {
        this.query.BerthLevel = "";
      }
      if(this.ApplyArea == 1127){
        this.query.AdultCount = this.AdultCount ? this.AdultCount : this.query.Consumers.length;
      }
      this.$router.push({ path: "flight/list", query: this.query as any });
    }

    selectCode = "";
    selectCity(cityType: string) {
      this.City = null;
      this.selectCode = cityType;
      this.$router.push({
        path: "/selectAirport",
        query: {
          ServiceType: this.query.ServiceType,
          ApplyArea: this.query.ApplyArea + "",
        },
      });
    }
    timeSelect(value: string) {
      if (value == "Arrive" && this.query.VoyageType == 1161) {
        return;
      }
      this.datePickerVisible = true;
    }
    changeCity() {
      this.changeCityFlag = !this.changeCityFlag;
      const newArriveCity = this.query.ArriveCity;
      const newArriveCityName = this.query.ArriveCityName;
      this.query.ArriveCity = this.query.DepartCity;
      this.query.ArriveCityName = this.query.DepartCityName;
      this.query.DepartCity = newArriveCity;
      this.query.DepartCityName = newArriveCityName;
    }

    Consumers = [];
    //选择乘客
    gotoAddPassengers() {
      dataShare.consumers = this.Consumers;
      this.$router.push("addPassengers");
    }
    //取消选择旅客
    closeBar(consumer: object) {
      this.Consumers = _.difference(this.Consumers, [consumer]) as any;
    }

    RetainTickets: TradeDetailEntity[] = [];
    loadRetainTickets() {
      let __self = this;
      let data = {
        Consumers: [],
        ConsumerCityCode: "",
        FinishedCityCode: "",
        BookingUserID: __self.profile.UserID,
      };
      billService.getUserTicketStatus(data).then(json => {
        if (json.isSucc && json.result) {
          __self.RetainTickets = json.result;
        }
      });
    }
    approvalList:any = [];
    searchapproval() {
       let __self = this;
       huilianyiService.searchapprovals().then((res:any) => {
         __self.approvalList = res.result;
       });
    }
    booking(data:any) {
     let __self = this;
     const id = data.companyId + data.approvalCode;
     huilianyiService.booking(id).then((res:any) => {
       if (res.isSucc) {
        const url = res.result.booking_url;
        if(this.parseUrlParams(url).productType!=='Flight') return this.$root.$toast.fail('业务类型不符，无法预订！');
        location.href = __self.getBookingUrl(url);
       }
     });
    }
    getBookingUrl(url:string){      
      // 获取当前页面的协议、域名和路径
      const currentOrigin = window.location.origin;
      const currentPathname = window.location.pathname;

      // 提取原 URL 中的查询参数部分（? 及其后面的内容）
      const queryIndex = url.indexOf('?');
      const queryPart = queryIndex !== -1 ? url.substring(queryIndex) : '';

      // 拼接新的 URL：当前路径 + 查询参数
      const booking_url = `${currentOrigin}${currentPathname}${queryPart}`;

      return booking_url;
    }
    parseUrlParams(url:string) {
      if (!url.includes("?")) return {};
      const query = url.split("?")[1].split("#")[0]; // 去掉 hash
      return Object.fromEntries(new URLSearchParams(query));
    }
  }
